<template>
    <div>
        <navigation-bar Back/>

        <div class="main container">
            <el-button @click="$router.push({ name: 'PrivacyPolicy' })">
                <img src="@/assets/images/account/privacy_policy.svg">
                隱私權條款
            </el-button>
            <el-button v-if="isLogin" @click="$router.push({ name: 'PhoneVerify', query: {nextTo: 'ChangePassword', tel: tel ,type: 'Code', countryCode: countryCode, countryName: countryName, reg:'register'} })">
                <img src="@/assets/images/account/change_password.svg">
                變更密碼
            </el-button>
            <el-button @click="deleteAccount">
                <img src="@/assets/images/account/delete_account.svg">
                刪除帳號
            </el-button>
            <el-button v-if="isLogin" @click="logoutDialog = true">
                <img src="@/assets/images/account/logout.svg">
                登出
            </el-button>
        </div>

        <logout :value="logoutDialog" @close="(value) => { logoutDialog = value }" />
        <comm-dialog :value="dialog.isShowDialog"
                     :outerContent="dialog.dialogMsg"
                     :isCancel="dialog.cancelable"
                     :positive-label="dialog.positiveLabel"
                     :is-text-box="dialog.isTextBox"
                     :text-type="dialog.textType"
                     :text-title="dialog.textTitle"
                     @result="onCommDialogClose"
                     :key=dialogRerenderNum />

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import Logout from "@/views/more/components/Logout";
    import * as mutationTypes from "@/store/mutationTypes";
    import * as constDefine from "@/store/constDefine";
    import CommDialog from "@/components/CommDialog";
    import auth from "@/util/auth";
    import crypto from "@/util/crypto";
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

    export default {
        name: "Account",
        components: { Logout, CommDialog },
        data() {
            return {
                isLoading: false,
                isLogin: true,
                logoutDialog: false,
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                    positiveLabel: '確定',
                    isTextBox: false,
                    textType: 'password',
                    textTitle: '請輸入密碼'
                },
                dialogRerenderNum: 0,
                func: function () {},
                password: '',
                tel: '',
                countryCode: '',
                countryName: '',
            }
        },
        created() {
            let userInfo = getCryptoUserInfo();
            if (userInfo !== undefined && userInfo !== null) {
                this.tel = userInfo.phone;
                this.countryCode = userInfo.countryCode;
                this.countryName = userInfo.countryName;
            }
        },
        mounted() {
            this.isLogin = this.$auth.isAdminLogin();
            //監聽 isLogout 事件
            this.$root.$on('isLogout', (isLogout) => {
                this.isLogin = !isLogout;

                //登出的話要清掉 fcm device token
                if (isLogout) {
                    this.isLoading = true;

                    //清除 user token
                    this.$auth.setAdminToken('');
                    //清除 fcm device token
                    let fcmToken = window.localStorage.getItem(constDefine.KEY_FCM_TOKEN);
                    window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, '');
                    this.fcmToken = '';
                    if(this.$public.isCordova()) {
                        this.clearTokenUserId(fcmToken);
                    } else {
                        this.$router.replace({name: 'More', params: { from: 'account', message: this.password === '' ? '已成功登出' : '已刪除帳號' }})
                    }
                }
            });
        },
        beforeDestroy() {
            //取消監聽 isLogout 事件
            this.$root.$off('isLogout');
        },
        methods: {
            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
                this.dialog.positiveLabel = '確定';
                this.dialog.isTextBox = false;
                this.func = () => { this.dialog.isShowDialog = false; };
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result, type, text) {
                this.password = '';
                if (result) {
                    if (text !== '') {
                        this.password = text;
                    }
                    this.func();
                }
            },

            /** 刪除個人 fcm token */
            clearTokenUserId: function (fcmToken) {
                this.isLoading = true;

                //是否爲 android 平臺？
                let os = this.$http.getOS();

                this.$http.fetch`ClearTokenUserId${{
                    'token': fcmToken,
                    'os': os
                }} ${json => {
                    this.isLoading = false;
                    if (json.status) {
                        this.$router.replace({name: 'More', params: { from: 'account', message: this.password === '' ? '已成功登出' : '已刪除帳號' }})
                    } else {
                        this.$store.commit(mutationTypes.SHOW_TOAST, "無法清除 fcm token");
                    }
                }}`;
            },

            /** 刪除帳號 */
            deleteAccount() {
                if (this.isLogin) {
                    this.dialog.isShowDialog = true;
                    this.dialog.dialogMsg = '請輸入密碼';
                    this.dialog.cancelable = true;
                    this.dialog.isTextBox = true;
                    this.dialog.textType = 'password';
                    this.dialog.textTitle = '';
                    this.dialog.positiveLabel = '確定';
                    this.dialogRerenderNum++;

                    this.func = () => {
                        this.isLoading = true;

                        this.$http.fetchWithAuthEncrypt`CheckAccount${{
                            'password': this.password,
                        }} ${json => {
                            this.isLoading = false;
                            if (json.status) {
                                let dataToken = this.$crypto.objectToURIComponent({
                                    usedType: "DeleteAccount",
                                    password: this.password,
                                })

                                this.$router.push({name: 'DeleteAccount', params: {dataToken: dataToken}})
                            } else {
                                this.$public.showNotify(json.message, json.status);
                            }
                        }}`;
                    }
                } else {
                    let dataToken = this.$crypto.objectToURIComponent({
                        usedType: "DeleteAccount",
                    })

                    this.$router.push({name: 'Login', params: {dataToken: dataToken}})
                }
            }
        },
    }
</script>
<style lang="less" scoped>
    .el-button{
        width: 100%;
        margin: 10px 0 10px !important;
        box-shadow: 0 0 4px rgba(102, 102, 102, 0.25);
        border: none;
        border-radius: 10px;
        text-align: left;
        display: flex;
        align-items: center;
    }
    img{
        width: 28px;
        margin-right: 8px;
    }
</style>
